import { render } from "./JourneyBadges.vue?vue&type=template&id=fd3b9284&scoped=true"
import script from "./JourneyBadges.vue?vue&type=script&lang=js"
export * from "./JourneyBadges.vue?vue&type=script&lang=js"

import "./JourneyBadges.vue?vue&type=style&index=0&id=fd3b9284&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3b9284"]])

export default __exports__